import http from '@/utils/http';

/**
 * 获取体检区域类型
 */
export const getTimeArea= () => {
    return http({
        url: '/api/area/v2/checkup/timearea',
        method: 'get'
    });
};

